import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import Utils from '../_com/utils';

/*
  Generated class for the AuthStore provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/
@Injectable()
export class AuthStore {

  /* アクセストークン */
  _token:string;
  set token(token:string){
    this._token = token;
  }
  get token(){
    return this._token;
  }

  /* ログイン情報 */
  _logedIn:{};
  set logedIn(user){
    this._logedIn = user;
  }
  get logedIn(){
    return this._logedIn;
  }

  getLogin(){
    return this.logedIn;
  }

  getLoginData(key){
    return this.logedIn[key];
  }

  getLoginName(){
    return Utils.getFullName(this.logedIn);
  }
}


// WEBPACK FOOTER //
// ./src/stores/auth-store.ts